<template>
	<div class="navbar">
		<span class="" style="font-size: 23px; text-align: center;">惠邻鸟</span>
		<div class="user">
			<el-dropdown @command="handleCommand">
				<div class="user-info">
					<img src="../../public/images/remind.svg" alt="" />
					<div style="padding-left: 16px; padding-right: 16px;">
						<img src="../../public/images/Avatar.png" alt="" />
					</div>

					<span class="el-dropdown-link">
						管理员 <i class="el-icon-arrow-down el-icon--right"></i>
					</span>
				</div>

				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="profile">消息中心</el-dropdown-item>
					<el-dropdown-item command="logout">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			handleCommand(command) {
				if (command === 'logout') {
					this.$confirm('确定要退出吗？', '退出提示', {
						type: 'warning'
					}).then(() => {
						this.$store.dispatch('auth/logout');
						this.$message.success('已退出')
						this.$router.push('/login')
					})
				} else if (command === 'profile') {
					this.$router.push('/myShop')
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.navbar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		padding: 0 20px;
		color: #000;
		font-weight: bold;

		.user-info {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.el-dropdown-link {
				cursor: pointer;
				color: #000;
			}
		}
	}
</style>
